"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deletePageConfig = deletePageConfig;
exports.getPageConfigDetail = getPageConfigDetail;
exports.getPageConfigList = getPageConfigList;
exports.savePageConfig = savePageConfig;
exports.updatePageConfig = updatePageConfig;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 分页查询页面配置
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
function getPageConfigList(params) {
  return (0, _requestAuth.default)({
    url: '/xyPopUpPageInfo/page',
    method: 'get',
    params: params
  });
}

/**
 * 保存页面配置（新增）
 * @param {Object} data - 页面配置数据
 * @returns {Promise}
 */
function savePageConfig(data) {
  return (0, _requestAuth.default)({
    url: '/xyPopUpPageInfo',
    method: 'post',
    data: data
  });
}

/**
 * 修改页面配置
 * @param {Object} data - 页面配置数据
 * @returns {Promise}
 */
function updatePageConfig(data) {
  return (0, _requestAuth.default)({
    url: '/xyPopUpPageInfo',
    method: 'put',
    data: data
  });
}

/**
 * 删除页面配置
 * @param {Long} id - 页面配置ID
 * @returns {Promise}
 */
function deletePageConfig(id) {
  return (0, _requestAuth.default)({
    url: "/xyPopUpPageInfo",
    method: 'delete',
    params: {
      id: id
    }
  });
}

/**
 * 获取页面配置详情
 * @param {Long} id - 页面配置ID
 * @returns {Promise}
 */
function getPageConfigDetail(id) {
  return (0, _requestAuth.default)({
    url: "/xyPopUpPageInfo/".concat(id),
    method: 'get'
  });
}